import { GRAN_LABEL, type Granularidad } from '../lib/serieGranularidad'

const OPCIONES: Granularidad[] = ['dia', 'semana', 'mes']

interface Props {
  value: Granularidad
  onChange: (g: Granularidad) => void
}

/**
 * Toggle segmentado Diario / Semanal / Mensual para las gráficas de serie
 * temporal. Pensado para colocarse en el header de `AreaChartFecha` vía el prop
 * `headerActions`.
 */
export function GranularidadToggle({ value, onChange }: Props) {
  return (
    <div className="inline-flex rounded-md border border-gray-300 dark:border-gray-700 bg-muted p-0.5">
      {OPCIONES.map((g) => (
        <button
          key={g}
          type="button"
          onClick={() => onChange(g)}
          className={`rounded px-2.5 py-1 text-xs font-medium transition-colors ${
            value === g
              ? 'bg-background text-foreground shadow-sm'
              : 'text-muted-foreground hover:text-foreground'
          }`}
        >
          {GRAN_LABEL[g]}
        </button>
      ))}
    </div>
  )
}
